// NO EDITAR A MANO
// const id = "footer.h3_footer";
const valor = `What are you waiting for to enjoy Meteored?`;

export default valor;
